/**
 * @file Higher order component responsible for firing a pageview.
 */

import React, { useEffect } from 'react';

import { gtm } from '../../../util/analytics';
import getConfig from '../../../util/config';

const withVirtualPageview =
  ({ path, title }) =>
  WrappedComponent =>
  props => {
    const config = getConfig();
    const { baseUrl } = config?.app ?? {};

    if (!path) {
      throw Error('withVirtualPageview: `path` is a required parameter.');
    }

    const { location, account } = props;

    useEffect(() => {
      // Track a virtual page view
      if (location) {
        gtm.trackPageView({
          url: `${baseUrl}${location.pathname}/virtual/${path}`,
          title: title ? `Virtual Pageview - ${title}` : 'Virtual Pageview',
          userId: account?.id ?? '',
        });
      }
    }, [account?.id]);

    return <WrappedComponent {...props} />;
  };

export default withVirtualPageview;
